<router-outlet (window:resize)="onResize($event)" (activate)="onActivate()" ></router-outlet>
